import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export async function getBankPayrun({ companyId, periodicId }) {
  try {
    const params = new URLSearchParams(url.search);
    if (companyId) {
      params.append("company_id", companyId);
    }
    if (periodicId) {
      params.append("periodic_id", periodicId);
    }

    const { data } = await axios.get(
      `${URL_API}/bank-payrun?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );

    return { success: true, message: "", data: data.data, code: 200 };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function createBankPayrun(payload) {
  try {
    const { data } = await axios.post(`${URL_API}/bank-payrun`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      data: data.data,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: null,
      errors: error.response.data.errors,
    };
  }
}

export async function updateBankPayrun({ id, payload }) {
  try {
    const { data } = await axios.put(`${URL_API}/bank-payrun/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      data: null,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
      errors: error.response.data.errors,
    };
  }
}

export async function deleteBankPayrun(id) {
  try {
    await axios.delete(`${URL_API}/bank-payrun/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: "",
      data: null,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      data: null,
      message: error.response.statusText,
    };
  }
}
